/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import "../Notfound//Notfound.css";
import React from "react";
import { ERROR_PAGE_LOGO, ERROR_LOGO } from "../../../constants/Constants";
export default class SystemFailure extends React.Component {
  render() {
    return (
      <div className="error-wrapper-network">
        <span
          className="close"
          data-dismiss="modal"
          aria-label="Close"
          onClick={this.props.close}
        >
          <strong aria-hidden="true">×</strong>
        </span>
        <div className="error_logo">
          <div className="error-img">
            <img alt="" src={ERROR_PAGE_LOGO} />
          </div>
        </div>
        <div className="error_message">
          <div className="container">
            <div className="error_inner">
              <div className="wizard-sad-logo">
                <img alt="" src={ERROR_LOGO} />
              </div>
              <div className="error_content">
                <h3>Uh-oh! The Spell Book vanished.</h3>
                <p className="e-con">
                  Fortunately, the Datazoom Wizards are working to conjure it
                  back into existence.
                </p>
                <p className="e-warning">
                  Fear not! Even through the UI is down your data is still
                  zooming <br /> and remains unaffected.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
